























import {Component, Vue} from 'vue-property-decorator'
import deviceModule from "@/store/module/DeviceModule";
import DeviceDetailView from "@/view/device-manage/device/detail.vue";
import ProductDetailView from "@/view/device-manage/product/detail.vue";
import productModule from "@/store/module/ProductModule";
import ProductApi from "@/module/device/ProductApi";
import {Container} from 'typescript-ioc';
import DeviceApi from "@/module/device/DeviceApi";

@Component({
  components: {
    DeviceDetailView,
    ProductDetailView,
  },
})
export default class DeviceDetailWrapperView extends Vue {

  private deviceApi = Container.get(DeviceApi)

  private productApi = Container.get(ProductApi)

  private view = 'dv'

  private get device() {
    return deviceModule.active
  }

  private async created() {
    await this.activateDevice()
    await this.activateProduct()
  }

  private async activateDevice() {
    const id = Number(this.$route.query.did)
    const device = await this.deviceApi.detail(id)
    await deviceModule.activate(device)
  }

  private async activateProduct() {
    const product = await this.productApi.query(this.device.product.id)
    await productModule.activate(product)
  }

  private destroyed() {
    deviceModule.destroy()
    productModule.destroy()
  }

  private loadProduct = false

  private handleChange(view: string) {
    if (view == 'pv')
      this.loadProduct = true
  }
}
